var map = {
	"./Icon_Library/application icons/api/data_mapping.svg2": 63850,
	"./Icon_Library/application icons/api/icon_3rd_party_api.svg2": 54308,
	"./Icon_Library/application icons/api/icon_advanced_settings.svg2": 79242,
	"./Icon_Library/application icons/api/icon_business_hours.svg2": 67921,
	"./Icon_Library/application icons/api/icon_data.svg2": 10886,
	"./Icon_Library/application icons/api/icon_log_files.svg2": 7363,
	"./Icon_Library/application icons/api/icon_logic_api.svg2": 86273,
	"./Icon_Library/application icons/api/icon_message_api.svg2": 57451,
	"./Icon_Library/application icons/api/icon_projects.svg2": 96799,
	"./Icon_Library/application icons/api/icon_testing.svg2": 71292,
	"./Icon_Library/application icons/api/icon_type_choose.svg2": 1042,
	"./Icon_Library/application icons/api/icon_verify.svg2": 30478,
	"./Icon_Library/application icons/api/import_side.svg2": 39134,
	"./Icon_Library/application icons/api/overview.svg2": 95458,
	"./Icon_Library/application icons/assets/asset_types/alert_building-01.svg2": 57479,
	"./Icon_Library/application icons/assets/asset_types/alert_fire-01.svg2": 78158,
	"./Icon_Library/application icons/assets/asset_types/alert_human_triggered-01.svg2": 31275,
	"./Icon_Library/application icons/assets/asset_types/alert_it-01.svg2": 36629,
	"./Icon_Library/application icons/assets/asset_types/alert_physical-01.svg2": 98783,
	"./Icon_Library/application icons/assets/asset_types/alert_power-01.svg2": 54452,
	"./Icon_Library/application icons/assets/asset_types/alert_stock-01.svg2": 14021,
	"./Icon_Library/application icons/assets/asset_types/alert_traffic_transportation-01.svg2": 70354,
	"./Icon_Library/application icons/assets/asset_types/alert_weather-01.svg2": 16691,
	"./Icon_Library/application icons/assets/assets.svg2": 86322,
	"./Icon_Library/application icons/assets/contacts_main.svg2": 7466,
	"./Icon_Library/application icons/assets/events.svg2": 36627,
	"./Icon_Library/application icons/assets/events/activate-01.svg2": 78877,
	"./Icon_Library/application icons/assets/events/add_circle-01.svg2": 79361,
	"./Icon_Library/application icons/assets/events/asset_events/asset.svg2": 54872,
	"./Icon_Library/application icons/assets/events/asset_events/human-01.svg2": 86506,
	"./Icon_Library/application icons/assets/events/asset_events/location_office-01.svg2": 34873,
	"./Icon_Library/application icons/assets/events/asset_events/location_school-01.svg2": 14816,
	"./Icon_Library/application icons/assets/events/asset_events/regional_office_hq-01.svg2": 1586,
	"./Icon_Library/application icons/assets/events/asset_events/server-01.svg2": 50315,
	"./Icon_Library/application icons/assets/events/asset_events/vehicle.svg2": 30701,
	"./Icon_Library/application icons/assets/events/assets_contacts-01.svg2": 99848,
	"./Icon_Library/application icons/assets/events/created_by-01.svg2": 74000,
	"./Icon_Library/application icons/assets/events/details-01.svg2": 85670,
	"./Icon_Library/application icons/assets/events/edit-01.svg2": 8637,
	"./Icon_Library/application icons/assets/events/event_start_end_cal-.svg2": 5694,
	"./Icon_Library/application icons/assets/events/event_type_alert-01.svg2": 92159,
	"./Icon_Library/application icons/assets/events/event_type_event-01.svg2": 32435,
	"./Icon_Library/application icons/assets/events/event_type_notification-01.svg2": 38074,
	"./Icon_Library/application icons/assets/events/import_event-01.svg2": 90292,
	"./Icon_Library/application icons/assets/events/layers/layer_bike-01.svg2": 29909,
	"./Icon_Library/application icons/assets/events/layers/layer_traffic-01.svg2": 31975,
	"./Icon_Library/application icons/assets/events/layers/layer_transit-01.svg2": 63346,
	"./Icon_Library/application icons/assets/events/locations/location_office-01.svg2": 38167,
	"./Icon_Library/application icons/assets/events/locations/location_school-01.svg2": 69753,
	"./Icon_Library/application icons/assets/events/logic_project-01.svg2": 48679,
	"./Icon_Library/application icons/assets/events/map_layers-01.svg2": 97180,
	"./Icon_Library/application icons/assets/events/one_off_comms-01.svg2": 81200,
	"./Icon_Library/application icons/assets/events/recipients-01.svg2": 3080,
	"./Icon_Library/application icons/assets/events/remove-01.svg2": 53602,
	"./Icon_Library/application icons/assets/events/send_method-01.svg2": 98977,
	"./Icon_Library/application icons/assets/events/step_complete-01.svg2": 13121,
	"./Icon_Library/application icons/assets/events/ticker-01.svg2": 37916,
	"./Icon_Library/application icons/assets/events/ticker_hide-01.svg2": 57154,
	"./Icon_Library/application icons/assets/events/ticker_pause-01.svg2": 71534,
	"./Icon_Library/application icons/assets/events/ticket_details-01.svg2": 9065,
	"./Icon_Library/application icons/assets/events/timeline-01.svg2": 73621,
	"./Icon_Library/application icons/assets/events/types/type_fire-01.svg2": 82891,
	"./Icon_Library/application icons/assets/events/types/type_terrorist-01.svg2": 63137,
	"./Icon_Library/application icons/assets/events/types/type_traffic-01.svg2": 20959,
	"./Icon_Library/application icons/assets/events/types/type_weather.svg2": 39699,
	"./Icon_Library/application icons/assets/groups.svg2": 1141,
	"./Icon_Library/application icons/assets/map_pin.svg2": 10782,
	"./Icon_Library/application icons/assets/weather.svg2": 62939,
	"./Icon_Library/application icons/billing/billing.svg2": 40642,
	"./Icon_Library/application icons/billing/billing_details.svg2": 37105,
	"./Icon_Library/application icons/billing/calendar_basic.svg2": 8034,
	"./Icon_Library/application icons/billing/inbound_numbers.svg2": 28385,
	"./Icon_Library/application icons/billing/invoices.svg2": 67379,
	"./Icon_Library/application icons/billing/overview.svg2": 37254,
	"./Icon_Library/application icons/billing/payment_methods.svg2": 70847,
	"./Icon_Library/application icons/billing/postpaid.svg2": 16056,
	"./Icon_Library/application icons/billing/status.svg2": 22606,
	"./Icon_Library/application icons/dashboard/create_api_connection.svg2": 41507,
	"./Icon_Library/application icons/dashboard/create_boomlogic.svg2": 78395,
	"./Icon_Library/application icons/dashboard/create_broadcast.svg2": 45290,
	"./Icon_Library/application icons/dashboard/create_inbound.svg2": 58806,
	"./Icon_Library/application icons/dashboard/icon_3rd_party_api.svg2": 61202,
	"./Icon_Library/application icons/dashboard/icon_logic_api.svg2": 117,
	"./Icon_Library/application icons/dashboard/icon_message_api.svg2": 36701,
	"./Icon_Library/application icons/general/add_circle.svg2": 15861,
	"./Icon_Library/application icons/general/admin_alt_a.svg2": 8717,
	"./Icon_Library/application icons/general/admin_alt_b.svg2": 69828,
	"./Icon_Library/application icons/general/alerts.svg2": 41283,
	"./Icon_Library/application icons/general/api_type.svg2": 99913,
	"./Icon_Library/application icons/general/arrow_right.svg2": 41330,
	"./Icon_Library/application icons/general/attach.svg2": 23914,
	"./Icon_Library/application icons/general/bolt.svg2": 42748,
	"./Icon_Library/application icons/general/boom_calendar.svg2": 28912,
	"./Icon_Library/application icons/general/boomlocal-forward.svg2": 38528,
	"./Icon_Library/application icons/general/bulk_manage.svg2": 98715,
	"./Icon_Library/application icons/general/button_logic_ready.svg2": 77294,
	"./Icon_Library/application icons/general/cal_event.svg2": 98898,
	"./Icon_Library/application icons/general/calendar.svg2": 75098,
	"./Icon_Library/application icons/general/chevon_down.svg2": 56758,
	"./Icon_Library/application icons/general/close.svg2": 4915,
	"./Icon_Library/application icons/general/cog.svg2": 59597,
	"./Icon_Library/application icons/general/comm_fields.svg2": 69862,
	"./Icon_Library/application icons/general/comms-delay.svg2": 74487,
	"./Icon_Library/application icons/general/concat.svg2": 35690,
	"./Icon_Library/application icons/general/connections.svg2": 64877,
	"./Icon_Library/application icons/general/contact_edit.svg2": 94453,
	"./Icon_Library/application icons/general/contact_support.svg2": 19393,
	"./Icon_Library/application icons/general/data_mapping.svg2": 82320,
	"./Icon_Library/application icons/general/edit.svg2": 3128,
	"./Icon_Library/application icons/general/engineer.svg2": 23148,
	"./Icon_Library/application icons/general/engineer_visit.svg2": 67679,
	"./Icon_Library/application icons/general/export.svg2": 65043,
	"./Icon_Library/application icons/general/filter.svg2": 80483,
	"./Icon_Library/application icons/general/free_build.svg2": 58477,
	"./Icon_Library/application icons/general/fulfilment.svg2": 27945,
	"./Icon_Library/application icons/general/groups_add.svg2": 8186,
	"./Icon_Library/application icons/general/import.svg2": 21315,
	"./Icon_Library/application icons/general/import_side.svg2": 56227,
	"./Icon_Library/application icons/general/incident_report.svg2": 69529,
	"./Icon_Library/application icons/general/info.svg2": 64311,
	"./Icon_Library/application icons/general/ldap.svg2": 10153,
	"./Icon_Library/application icons/general/manage_fields.svg2": 25516,
	"./Icon_Library/application icons/general/mapping.svg2": 65228,
	"./Icon_Library/application icons/general/marketing_fields.svg2": 39366,
	"./Icon_Library/application icons/general/masking.svg2": 24740,
	"./Icon_Library/application icons/general/message_recipients.svg2": 85762,
	"./Icon_Library/application icons/general/messages.svg2": 21332,
	"./Icon_Library/application icons/general/messages_processed.svg2": 64586,
	"./Icon_Library/application icons/general/messenger.svg2": 73120,
	"./Icon_Library/application icons/general/movable.svg2": 37368,
	"./Icon_Library/application icons/general/num-status.svg2": 7399,
	"./Icon_Library/application icons/general/num-validation.svg2": 8841,
	"./Icon_Library/application icons/general/omni-channel.svg2": 40268,
	"./Icon_Library/application icons/general/opt-in-out.svg2": 1284,
	"./Icon_Library/application icons/general/originator.svg2": 98031,
	"./Icon_Library/application icons/general/personal_details.svg2": 32426,
	"./Icon_Library/application icons/general/plus.svg2": 35740,
	"./Icon_Library/application icons/general/preview.svg2": 66861,
	"./Icon_Library/application icons/general/print.svg2": 48961,
	"./Icon_Library/application icons/general/prod_api.svg2": 58604,
	"./Icon_Library/application icons/general/prod_boomlogic.svg2": 97411,
	"./Icon_Library/application icons/general/prod_broadcast.svg2": 37614,
	"./Icon_Library/application icons/general/prod_inbound.svg2": 21155,
	"./Icon_Library/application icons/general/profile_fields.svg2": 88868,
	"./Icon_Library/application icons/general/redo.svg2": 39860,
	"./Icon_Library/application icons/general/reports_export.svg2": 20334,
	"./Icon_Library/application icons/general/reports_generate.svg2": 19536,
	"./Icon_Library/application icons/general/reports_saved.svg2": 18624,
	"./Icon_Library/application icons/general/required_fields.svg2": 36201,
	"./Icon_Library/application icons/general/satisfaction_survey.svg2": 35007,
	"./Icon_Library/application icons/general/save.svg2": 18684,
	"./Icon_Library/application icons/general/schedule_send.svg2": 84437,
	"./Icon_Library/application icons/general/scheduling.svg2": 39480,
	"./Icon_Library/application icons/general/search.svg2": 27606,
	"./Icon_Library/application icons/general/secure_lock..svg2": 78079,
	"./Icon_Library/application icons/general/self-manage.svg2": 23168,
	"./Icon_Library/application icons/general/send.svg2": 31209,
	"./Icon_Library/application icons/general/service_entries.svg2": 62098,
	"./Icon_Library/application icons/general/shortlink.svg2": 5765,
	"./Icon_Library/application icons/general/sla.svg2": 54170,
	"./Icon_Library/application icons/general/sms_text.svg2": 23518,
	"./Icon_Library/application icons/general/social-hours.svg2": 20382,
	"./Icon_Library/application icons/general/social_fb.svg2": 71992,
	"./Icon_Library/application icons/general/social_li.svg2": 47660,
	"./Icon_Library/application icons/general/social_x.svg2": 34915,
	"./Icon_Library/application icons/general/support_ticket.svg2": 45554,
	"./Icon_Library/application icons/general/switch_refresh.svg2": 64982,
	"./Icon_Library/application icons/general/system_usage.svg2": 99838,
	"./Icon_Library/application icons/general/template_account.svg2": 25887,
	"./Icon_Library/application icons/general/template_boomerang.svg2": 28430,
	"./Icon_Library/application icons/general/template_helper.svg2": 68611,
	"./Icon_Library/application icons/general/tick.svg2": 5784,
	"./Icon_Library/application icons/general/tick_circled.svg2": 95207,
	"./Icon_Library/application icons/general/tick_list.svg2": 47913,
	"./Icon_Library/application icons/general/timezones.svg2": 88529,
	"./Icon_Library/application icons/general/undo.svg2": 28843,
	"./Icon_Library/application icons/general/unicode.svg2": 36916,
	"./Icon_Library/application icons/general/unrec-response.svg2": 5193,
	"./Icon_Library/application icons/general/upgrades.svg2": 15648,
	"./Icon_Library/application icons/general/upload.svg2": 1210,
	"./Icon_Library/application icons/general/upload_file-01.svg2": 96038,
	"./Icon_Library/application icons/general/user_group.svg2": 97268,
	"./Icon_Library/application icons/general/web-forms.svg2": 61131,
	"./Icon_Library/application icons/general/whatsapp.svg2": 33743,
	"./Icon_Library/application icons/general/xls_files.svg2": 27697,
	"./Icon_Library/application icons/interactions/interactions.svg2": 93038,
	"./Icon_Library/application icons/library/api_data_connections.svg2": 52706,
	"./Icon_Library/application icons/library/api_profiles.svg2": 40948,
	"./Icon_Library/application icons/library/boomAI_icon.svg2": 6464,
	"./Icon_Library/application icons/library/boomAI_icon_white.svg2": 94307,
	"./Icon_Library/application icons/library/contacts_main.svg2": 12099,
	"./Icon_Library/application icons/library/icon_translate.svg2": 46477,
	"./Icon_Library/application icons/library/library.svg2": 9925,
	"./Icon_Library/application icons/library/library_broadcast.svg2": 57983,
	"./Icon_Library/application icons/library/library_documents.svg2": 76218,
	"./Icon_Library/application icons/library/library_logic.svg2": 19846,
	"./Icon_Library/application icons/library/solutions.svg2": 14139,
	"./Icon_Library/application icons/library/weather.svg2": 16465,
	"./Icon_Library/application icons/menus/main navigation/boomerang_element-01.svg2": 87231,
	"./Icon_Library/application icons/menus/main navigation/logout.svg2": 69254,
	"./Icon_Library/application icons/menus/main navigation/nav_assets.svg2": 39220,
	"./Icon_Library/application icons/menus/main navigation/nav_billing.svg2": 75128,
	"./Icon_Library/application icons/menus/main navigation/nav_contacts.svg2": 26662,
	"./Icon_Library/application icons/menus/main navigation/nav_dashboard.svg2": 51606,
	"./Icon_Library/application icons/menus/main navigation/nav_interactions.svg2": 1261,
	"./Icon_Library/application icons/menus/main navigation/nav_monitoring.svg2": 15135,
	"./Icon_Library/application icons/menus/main navigation/nav_reports.svg2": 87117,
	"./Icon_Library/application icons/menus/main navigation/nav_settings.svg2": 31581,
	"./Icon_Library/application icons/menus/main navigation/nav_templates.svg2": 12791,
	"./Icon_Library/application icons/menus/top navigation/chevon_down.svg2": 18697,
	"./Icon_Library/application icons/menus/top navigation/docs.svg2": 68254,
	"./Icon_Library/application icons/menus/top navigation/info.svg2": 96071,
	"./Icon_Library/application icons/menus/top navigation/live_chat.svg2": 11764,
	"./Icon_Library/application icons/menus/top navigation/menu.svg2": 16846,
	"./Icon_Library/application icons/monitoring/alerts_notifications-01.svg2": 69938,
	"./Icon_Library/application icons/monitoring/check_tick-01.svg2": 5883,
	"./Icon_Library/application icons/monitoring/configuration-01.svg2": 30215,
	"./Icon_Library/application icons/monitoring/icon_alert.svg2": 39122,
	"./Icon_Library/application icons/monitoring/icon_heartbeat_1.svg2": 65199,
	"./Icon_Library/application icons/monitoring/icon_heartbeat_2.svg2": 2861,
	"./Icon_Library/application icons/monitoring/icon_ping .svg2": 5301,
	"./Icon_Library/application icons/monitoring/industries/industry_construction-01.svg2": 67752,
	"./Icon_Library/application icons/monitoring/map_view-01.svg2": 44882,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_environmental_conditions-01.svg2": 95398,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_remote_devices-01.svg2": 80214,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_weather.svg2": 67632,
	"./Icon_Library/application icons/monitoring/monitor_types/mon_welfare-01.svg2": 11631,
	"./Icon_Library/application icons/monitoring/monitoring-01.svg2": 69153,
	"./Icon_Library/application icons/monitoring/monitors_overview-01.svg2": 61335,
	"./Icon_Library/application icons/monitoring/save-01.svg2": 59452,
	"./Icon_Library/application icons/monitoring/select_workflow-01.svg2": 3060,
	"./Icon_Library/application icons/monitoring/setup-01.svg2": 63523,
	"./Icon_Library/application icons/monitoring/view_manage_monitors-01.svg2": 1674,
	"./Icon_Library/application icons/reports/assets.svg2": 84049,
	"./Icon_Library/application icons/reports/billing.svg2": 40306,
	"./Icon_Library/application icons/reports/features.svg2": 5200,
	"./Icon_Library/application icons/reports/messaging_data.svg2": 89131,
	"./Icon_Library/application icons/reports/process_reports.svg2": 86018,
	"./Icon_Library/application icons/reports/realtime_reporting.svg2": 23834,
	"./Icon_Library/application icons/reports/reporting_analytical.svg2": 3760,
	"./Icon_Library/application icons/reports/reporting_system.svg2": 79726,
	"./Icon_Library/application icons/reports/reports.svg2": 36836,
	"./Icon_Library/application icons/reports/tiket_reporting.svg2": 38338,
	"./Icon_Library/application icons/reports/workflows.svg2": 95201,
	"./Icon_Library/application icons/settings/comms_defaults.svg2": 10712,
	"./Icon_Library/application icons/settings/communications.svg2": 99569,
	"./Icon_Library/application icons/settings/company.svg2": 8730,
	"./Icon_Library/application icons/settings/invoices.svg2": 60755,
	"./Icon_Library/application icons/settings/organisation.svg2": 28917,
	"./Icon_Library/application icons/settings/security.svg2": 30538,
	"./Icon_Library/application icons/settings/settings.svg2": 79294,
	"./Icon_Library/application icons/settings/sms_settings.svg2": 76364,
	"./Icon_Library/application icons/settings/status.svg2": 56585,
	"./Icon_Library/application icons/settings/timezones.svg2": 86277,
	"./Icon_Library/application icons/settings/users.svg2": 62024,
	"./Icon_Library/application icons/settings/users_roles.svg2": 72256,
	"./Icon_Library/application icons/weather/codes_conditions/clear_sky-01.svg2": 14771,
	"./Icon_Library/application icons/weather/codes_conditions/cloudy-01.svg2": 82634,
	"./Icon_Library/application icons/weather/codes_conditions/drizzle-01.svg2": 55771,
	"./Icon_Library/application icons/weather/codes_conditions/fog-01.svg2": 21108,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_rain-01.svg2": 68979,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_rain_shower-01.svg2": 57736,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_snow-01.svg2": 15370,
	"./Icon_Library/application icons/weather/codes_conditions/heavy_snow_shower-01.svg2": 41217,
	"./Icon_Library/application icons/weather/codes_conditions/light_rain-01.svg2": 67815,
	"./Icon_Library/application icons/weather/codes_conditions/light_rain_shower-01.svg2": 66568,
	"./Icon_Library/application icons/weather/codes_conditions/light_snow-01.svg2": 58208,
	"./Icon_Library/application icons/weather/codes_conditions/light_snow_shower-01.svg2": 53184,
	"./Icon_Library/application icons/weather/codes_conditions/max_screen_temp-01.svg2": 45158,
	"./Icon_Library/application icons/weather/codes_conditions/min_screen_temp-01.svg2": 18896,
	"./Icon_Library/application icons/weather/codes_conditions/mist-01.svg2": 67947,
	"./Icon_Library/application icons/weather/codes_conditions/overcast-01.svg2": 32987,
	"./Icon_Library/application icons/weather/codes_conditions/partly_cloudy-01.svg2": 50196,
	"./Icon_Library/application icons/weather/codes_conditions/probability_of_snow_visibility-01.svg2": 64842,
	"./Icon_Library/application icons/weather/codes_conditions/significant_weather-01.svg2": 20439,
	"./Icon_Library/application icons/weather/codes_conditions/sleet-01.svg2": 71006,
	"./Icon_Library/application icons/weather/codes_conditions/sleet_shower-01.svg2": 78366,
	"./Icon_Library/application icons/weather/codes_conditions/sunny-01.svg2": 5037,
	"./Icon_Library/application icons/weather/codes_conditions/thunder-01.svg2": 46292,
	"./Icon_Library/application icons/weather/codes_conditions/thunder_shower-01.svg2": 92636,
	"./Icon_Library/application icons/weather/codes_conditions/wind_direction.svg2": 19529,
	"./Icon_Library/application icons/weather/codes_conditions/wind_speed-01.svg2": 2038,
	"./Icon_Library/application icons/weather/map_markers/hail.svg2": 825,
	"./Icon_Library/application icons/weather/map_markers/humidity.svg2": 16987,
	"./Icon_Library/application icons/weather/map_markers/lightning.svg2": 65888,
	"./Icon_Library/application icons/weather/map_markers/precipitation.svg2": 31623,
	"./Icon_Library/application icons/weather/map_markers/pressure.svg2": 57155,
	"./Icon_Library/application icons/weather/map_markers/rain.svg2": 99214,
	"./Icon_Library/application icons/weather/map_markers/snow.svg2": 42130,
	"./Icon_Library/application icons/weather/map_markers/temperature.svg2": 58377,
	"./Icon_Library/application icons/weather/map_markers/uv.svg2": 51943,
	"./Icon_Library/application icons/weather/map_markers/visibility.svg2": 54024,
	"./Icon_Library/application icons/weather/map_markers/wind_direction.svg2": 15740,
	"./Icon_Library/application icons/weather/weather.svg2": 54853,
	"./Icon_Library/cube icons/account_template-01.svg2": 83814,
	"./Icon_Library/cube icons/activation_opt_ins-01.svg2": 54709,
	"./Icon_Library/cube icons/active_groups.svg2": 86606,
	"./Icon_Library/cube icons/add_edit_contacts-01.svg2": 14443,
	"./Icon_Library/cube icons/aggregate-01.svg2": 1445,
	"./Icon_Library/cube icons/aggregate_responses-01.svg2": 4439,
	"./Icon_Library/cube icons/ai_conversations-01.svg2": 46835,
	"./Icon_Library/cube icons/ai_management-01.svg2": 5513,
	"./Icon_Library/cube icons/alerts_notifcations-01.svg2": 2716,
	"./Icon_Library/cube icons/analytical_reporting-01.svg2": 4487,
	"./Icon_Library/cube icons/api_connections-01.svg2": 18777,
	"./Icon_Library/cube icons/assets-01.svg2": 5790,
	"./Icon_Library/cube icons/attachments.svg2": 46926,
	"./Icon_Library/cube icons/boomerang_template-01.svg2": 26758,
	"./Icon_Library/cube icons/boomlogic_projects-01.svg2": 94291,
	"./Icon_Library/cube icons/broadcast-01.svg2": 82982,
	"./Icon_Library/cube icons/bulk_manage-01.svg2": 81862,
	"./Icon_Library/cube icons/comms_delay-01.svg2": 69895,
	"./Icon_Library/cube icons/connections-01.svg2": 88292,
	"./Icon_Library/cube icons/contacts-01.svg2": 96841,
	"./Icon_Library/cube icons/count_collate_data-01.svg2": 96341,
	"./Icon_Library/cube icons/data_analysis-01.svg2": 7386,
	"./Icon_Library/cube icons/data_overwrite-01.svg2": 96632,
	"./Icon_Library/cube icons/delay_send-01.svg2": 61662,
	"./Icon_Library/cube icons/delivery_statuses-01.svg2": 94577,
	"./Icon_Library/cube icons/export_reports-01.svg2": 23117,
	"./Icon_Library/cube icons/filtering-01.svg2": 14664,
	"./Icon_Library/cube icons/freebuild-01.svg2": 32798,
	"./Icon_Library/cube icons/generate_reports-01.svg2": 67358,
	"./Icon_Library/cube icons/groups-01.svg2": 92797,
	"./Icon_Library/cube icons/import-01.svg2": 54633,
	"./Icon_Library/cube icons/inbound_campaign-01.svg2": 80113,
	"./Icon_Library/cube icons/inbound_numbers-01.svg2": 67368,
	"./Icon_Library/cube icons/invoices-01.svg2": 43930,
	"./Icon_Library/cube icons/knowledgebase-01.svg2": 38791,
	"./Icon_Library/cube icons/logic_components_library-01.svg2": 76641,
	"./Icon_Library/cube icons/map_pin-01.svg2": 35725,
	"./Icon_Library/cube icons/mapping-01.svg2": 30574,
	"./Icon_Library/cube icons/marketing_fields-01.svg2": 63806,
	"./Icon_Library/cube icons/masking-01.svg2": 86009,
	"./Icon_Library/cube icons/matched_replies-01.svg2": 30188,
	"./Icon_Library/cube icons/number_status-01.svg2": 23307,
	"./Icon_Library/cube icons/number_validation-01.svg2": 29044,
	"./Icon_Library/cube icons/omni_channel-01.svg2": 98325,
	"./Icon_Library/cube icons/paymnet_methods-01.svg2": 21270,
	"./Icon_Library/cube icons/preview-01.svg2": 56931,
	"./Icon_Library/cube icons/process_reports-01.svg2": 71545,
	"./Icon_Library/cube icons/progress_saving-01.svg2": 14914,
	"./Icon_Library/cube icons/real_time_reporting-01.svg2": 8560,
	"./Icon_Library/cube icons/replies-01.svg2": 23317,
	"./Icon_Library/cube icons/reporting-01.svg2": 24320,
	"./Icon_Library/cube icons/saved_reports-01.svg2": 47184,
	"./Icon_Library/cube icons/schedule_send-01.svg2": 41763,
	"./Icon_Library/cube icons/security-01.svg2": 99649,
	"./Icon_Library/cube icons/service_entries-01.svg2": 75534,
	"./Icon_Library/cube icons/service_usage-01.svg2": 40272,
	"./Icon_Library/cube icons/settings-01.svg2": 96122,
	"./Icon_Library/cube icons/shortlinks-01.svg2": 97215,
	"./Icon_Library/cube icons/sla-01.svg2": 98440,
	"./Icon_Library/cube icons/social_hours-01.svg2": 61482,
	"./Icon_Library/cube icons/system_reporting-01.svg2": 48948,
	"./Icon_Library/cube icons/template_library-01.svg2": 71746,
	"./Icon_Library/cube icons/template_qanda-01.svg2": 81004,
	"./Icon_Library/cube icons/ticketing_reports-01.svg2": 61503,
	"./Icon_Library/cube icons/timezones-01.svg2": 65906,
	"./Icon_Library/cube icons/unmatched_replies-01.svg2": 79531,
	"./Icon_Library/cube icons/unrec_responses-01.svg2": 89028,
	"./Icon_Library/cube icons/upgrades-01.svg2": 18704,
	"./Icon_Library/cube icons/user_access_controls-01.svg2": 4388,
	"./Icon_Library/cube icons/variable_data-01.svg2": 94538,
	"./Icon_Library/cube icons/web_forms-01.svg2": 26383,
	"./Icon_Library/cube icons/weighting-01.svg2": 25647,
	"./Icon_Library/solutions icons/app_colouring/sol_app_booking_reminders-01.svg2": 51034,
	"./Icon_Library/solutions icons/app_colouring/sol_app_booking_rescheduling-01.svg2": 43980,
	"./Icon_Library/solutions icons/app_colouring/sol_asset_tracking-01.svg2": 99644,
	"./Icon_Library/solutions icons/app_colouring/sol_booking_requests-01.svg2": 23071,
	"./Icon_Library/solutions icons/app_colouring/sol_business_continuity_comms-01.svg2": 83859,
	"./Icon_Library/solutions icons/app_colouring/sol_collection_reminders-01.svg2": 14002,
	"./Icon_Library/solutions icons/app_colouring/sol_contact_center_eng-01.svg2": 98829,
	"./Icon_Library/solutions icons/app_colouring/sol_contact_center_ivr-01.svg2": 3010,
	"./Icon_Library/solutions icons/app_colouring/sol_contact_management-01.svg2": 41630,
	"./Icon_Library/solutions icons/app_colouring/sol_customer_initiated_engagement-01.svg2": 13502,
	"./Icon_Library/solutions icons/app_colouring/sol_debt_recovery-01.svg2": 97917,
	"./Icon_Library/solutions icons/app_colouring/sol_doc_workflow-01.svg2": 17037,
	"./Icon_Library/solutions icons/app_colouring/sol_environmental_monitoring-01.svg2": 78196,
	"./Icon_Library/solutions icons/app_colouring/sol_field_force_comms-01.svg2": 2969,
	"./Icon_Library/solutions icons/app_colouring/sol_field_force_scheduling-01.svg2": 27448,
	"./Icon_Library/solutions icons/app_colouring/sol_inbound_marketing-01.svg2": 50636,
	"./Icon_Library/solutions icons/app_colouring/sol_incident_management-01.svg2": 5315,
	"./Icon_Library/solutions icons/app_colouring/sol_info_requests-01.svg2": 54371,
	"./Icon_Library/solutions icons/app_colouring/sol_instant_auth-01.svg2": 2236,
	"./Icon_Library/solutions icons/app_colouring/sol_iot_monitoring-01.svg2": 73712,
	"./Icon_Library/solutions icons/app_colouring/sol_it_monitoring_alerting-01.svg2": 2719,
	"./Icon_Library/solutions icons/app_colouring/sol_lone_worker-01.svg2": 10157,
	"./Icon_Library/solutions icons/app_colouring/sol_machine_2_machine-01.svg2": 13226,
	"./Icon_Library/solutions icons/app_colouring/sol_marketing_campaigns-01.svg2": 13566,
	"./Icon_Library/solutions icons/app_colouring/sol_membership_sub_management-01.svg2": 73338,
	"./Icon_Library/solutions icons/app_colouring/sol_mustering-01.svg2": 84585,
	"./Icon_Library/solutions icons/app_colouring/sol_opt_in_opt_out_management-01.svg2": 79994,
	"./Icon_Library/solutions icons/app_colouring/sol_order_delivery_management-01.svg2": 22412,
	"./Icon_Library/solutions icons/app_colouring/sol_payment_reminders-01.svg2": 40471,
	"./Icon_Library/solutions icons/app_colouring/sol_resource_managment_fulfilment-01.svg2": 30175,
	"./Icon_Library/solutions icons/app_colouring/sol_service_desk_ticketing-01.svg2": 54109,
	"./Icon_Library/solutions icons/app_colouring/sol_service_sla-01.svg2": 78816,
	"./Icon_Library/solutions icons/app_colouring/sol_shift_planning-01.svg2": 99158,
	"./Icon_Library/solutions icons/app_colouring/sol_sub_renewals-01.svg2": 91171,
	"./Icon_Library/solutions icons/app_colouring/sol_survey_sms-01.svg2": 36678,
	"./Icon_Library/solutions icons/app_colouring/sol_survey_web-01.svg2": 27177,
	"./Icon_Library/solutions icons/app_colouring/sol_traffic_alerts-01.svg2": 56444,
	"./Icon_Library/solutions icons/app_colouring/sol_weather_alerts-01.svg2": 97293,
	"./Icon_Library/solutions icons/sol_app_booking_reminders-01.svg2": 10780,
	"./Icon_Library/solutions icons/sol_app_booking_rescheduling-01.svg2": 38000,
	"./Icon_Library/solutions icons/sol_asset_tracking-01.svg2": 55219,
	"./Icon_Library/solutions icons/sol_booking_requests-01.svg2": 33319,
	"./Icon_Library/solutions icons/sol_business_continuity_comms-01.svg2": 32728,
	"./Icon_Library/solutions icons/sol_collection_reminders-01.svg2": 8279,
	"./Icon_Library/solutions icons/sol_contact_center_eng-01.svg2": 48767,
	"./Icon_Library/solutions icons/sol_contact_center_ivr-01.svg2": 95897,
	"./Icon_Library/solutions icons/sol_contact_management-01.svg2": 22409,
	"./Icon_Library/solutions icons/sol_customer_initiated_engagement-01.svg2": 12281,
	"./Icon_Library/solutions icons/sol_debt_recovery-01.svg2": 42217,
	"./Icon_Library/solutions icons/sol_doc_workflow-01.svg2": 8600,
	"./Icon_Library/solutions icons/sol_environmental_monitoring-01.svg2": 53943,
	"./Icon_Library/solutions icons/sol_field_force_comms-01.svg2": 74865,
	"./Icon_Library/solutions icons/sol_field_force_scheduling-01.svg2": 41542,
	"./Icon_Library/solutions icons/sol_inbound_marketing-01.svg2": 92076,
	"./Icon_Library/solutions icons/sol_incident_management-01.svg2": 6443,
	"./Icon_Library/solutions icons/sol_info_requests-01.svg2": 56787,
	"./Icon_Library/solutions icons/sol_instant_auth-01.svg2": 45328,
	"./Icon_Library/solutions icons/sol_iot_monitoring-01.svg2": 15152,
	"./Icon_Library/solutions icons/sol_it_monitoring_alerting-01.svg2": 30194,
	"./Icon_Library/solutions icons/sol_lone_worker-01.svg2": 384,
	"./Icon_Library/solutions icons/sol_machine_2_machine-01.svg2": 69747,
	"./Icon_Library/solutions icons/sol_marketing_campaigns-01.svg2": 12062,
	"./Icon_Library/solutions icons/sol_membership_sub_management-01.svg2": 81110,
	"./Icon_Library/solutions icons/sol_mustering-01.svg2": 35764,
	"./Icon_Library/solutions icons/sol_opt_in_opt_out_management-01.svg2": 10842,
	"./Icon_Library/solutions icons/sol_order_delivery_management-01.svg2": 62637,
	"./Icon_Library/solutions icons/sol_payment_reminders-01.svg2": 63812,
	"./Icon_Library/solutions icons/sol_resource_managment_fulfilment-01.svg2": 46109,
	"./Icon_Library/solutions icons/sol_service_desk_ticketing-01.svg2": 44981,
	"./Icon_Library/solutions icons/sol_service_sla-01.svg2": 87358,
	"./Icon_Library/solutions icons/sol_shift_planning-01.svg2": 61563,
	"./Icon_Library/solutions icons/sol_sub_renewals-01.svg2": 48075,
	"./Icon_Library/solutions icons/sol_survey_sms-01.svg2": 33678,
	"./Icon_Library/solutions icons/sol_survey_web-01.svg2": 69509,
	"./Icon_Library/solutions icons/sol_traffic_alerts-01.svg2": 79830,
	"./Icon_Library/solutions icons/sol_weather_alerts-01.svg2": 83704,
	"./add_circle-01.svg2": 4114,
	"./alerts.svg2": 35305,
	"./api_cog-01.svg2": 51173,
	"./api_connections.svg2": 63367,
	"./api_type-01.svg2": 33762,
	"./arrow_right-01.svg2": 65331,
	"./asset-01.svg2": 62193,
	"./attach.svg2": 10787,
	"./billing_overview.svg2": 92801,
	"./bolt.svg2": 37057,
	"./boom_calendar-01.svg2": 67655,
	"./boomerang_element-01.svg2": 28708,
	"./boomlocal-forward.svg2": 42804,
	"./briefcase.svg2": 44107,
	"./bulk_manage.svg2": 54443,
	"./button_logic_ready.svg2": 82541,
	"./cal_basic-01.svg2": 18590,
	"./cal_event-01.svg2": 89856,
	"./calendar.svg2": 66179,
	"./chevon_down.svg2": 20244,
	"./close.svg2": 28695,
	"./cog.svg2": 47143,
	"./comm_fields.svg2": 3065,
	"./comms-delay.svg2": 66105,
	"./componenets.svg2": 66199,
	"./concat.svg2": 41473,
	"./connections.svg2": 45173,
	"./contact_edit.svg2": 90965,
	"./contact_support.svg2": 9356,
	"./contacts_main.svg2": 9264,
	"./contacts_main_nav.svg2": 37920,
	"./create_api_connection.svg2": 33912,
	"./create_boomlogic.svg2": 76778,
	"./create_broadcast.svg2": 58525,
	"./create_inbound.svg2": 51935,
	"./customers.svg2": 8633,
	"./data_mapping-01.svg2": 68085,
	"./docs.svg2": 39591,
	"./edit-01.svg2": 21884,
	"./edit.svg2": 40576,
	"./engineer.svg2": 45511,
	"./engineer_visit.svg2": 70071,
	"./export.svg2": 59940,
	"./features.svg2": 723,
	"./filter.svg2": 57228,
	"./filter_solid.svg2": 84263,
	"./free_build.svg2": 69442,
	"./fulfilment.svg2": 12335,
	"./global_settings.svg2": 5818,
	"./groups.svg2": 88720,
	"./groups_add.svg2": 34673,
	"./hail.svg2": 46358,
	"./humidity.svg2": 53077,
	"./icon_1_way-01.svg2": 9799,
	"./icon_2_way-01.svg2": 18916,
	"./icon_activation_criteria-01.svg2": 49352,
	"./icon_activation_keywords-01.svg2": 49313,
	"./icon_address-01.svg2": 56778,
	"./icon_api_endpoints-01.svg2": 40468,
	"./icon_clicks-01.svg2": 91463,
	"./icon_communications-01.svg2": 22893,
	"./icon_contact_data_types-01.svg2": 13096,
	"./icon_contacts-01.svg2": 66014,
	"./icon_counter-01.svg2": 53227,
	"./icon_data_variables-01.svg2": 93262,
	"./icon_date_picker-01.svg2": 27216,
	"./icon_date_time-01.svg2": 24973,
	"./icon_distance-01.svg2": 1111,
	"./icon_duration-01.svg2": 49978,
	"./icon_email-01.svg2": 9587,
	"./icon_group-01.svg2": 84671,
	"./icon_inbound-01.svg2": 89635,
	"./icon_mobile_number-01.svg2": 77083,
	"./icon_rcs-01.svg2": 10625,
	"./icon_recipients-01.svg2": 14012,
	"./icon_repeat-01.svg2": 3745,
	"./icon_replies-01.svg2": 48038,
	"./icon_reporting_financials_white-01.svg2": 44954,
	"./icon_reports-01.svg2": 70771,
	"./icon_responders-01.svg2": 27002,
	"./icon_save-01.svg2": 22544,
	"./icon_shorttext-01.svg2": 70508,
	"./icon_status-01.svg2": 74875,
	"./icon_voice_tel-01.svg2": 40656,
	"./icon_warning-01.svg2": 50570,
	"./icon_weather_header.svg2": 59476,
	"./icon_weather_header_c-01.svg2": 46605,
	"./icon_weather_header_dark.svg2": 14496,
	"./icon_whatsapp-01.svg2": 51246,
	"./import-01.svg2": 86703,
	"./import_side-01.svg2": 91156,
	"./inbound_numbers.svg2": 46095,
	"./incident_report.svg2": 98964,
	"./info-01.svg2": 69824,
	"./info.svg2": 19072,
	"./interactions.svg2": 73648,
	"./interactions_nav.svg2": 80965,
	"./invoice_history.svg2": 48799,
	"./invoicing.svg2": 79712,
	"./knowledgebase-01.svg2": 38156,
	"./ldap-01.svg2": 44930,
	"./library_broadcast.svg2": 20010,
	"./library_documents.svg2": 67989,
	"./library_logic.svg2": 56375,
	"./library_puzzle.svg2": 97226,
	"./lightning.svg2": 10542,
	"./live_chat.svg2": 90693,
	"./logout.svg2": 54905,
	"./mapping.svg2": 55818,
	"./marketing_fields.svg2": 49146,
	"./masking.svg2": 23275,
	"./menu.svg2": 21715,
	"./message_recipients.svg2": 25068,
	"./messages-01.svg2": 17920,
	"./messages.svg2": 40582,
	"./messages_processed-01.svg2": 21604,
	"./messages_processed.svg2": 68209,
	"./messenger.svg2": 84864,
	"./monitoring/alerts_notifications-01.svg2": 51395,
	"./monitoring/check_tick-01.svg2": 95677,
	"./monitoring/configuration-01.svg2": 15906,
	"./monitoring/icon_ping (1).svg2": 15021,
	"./monitoring/industries/industry_construction-01.svg2": 39290,
	"./monitoring/map_view-01.svg2": 45823,
	"./monitoring/monitor_types/icon_alert.svg2": 41430,
	"./monitoring/monitor_types/mon_environmental_conditions-01.svg2": 73399,
	"./monitoring/monitor_types/mon_remote_devices-01.svg2": 83270,
	"./monitoring/monitor_types/mon_weather.svg2": 77560,
	"./monitoring/monitor_types/mon_welfare-01.svg2": 34474,
	"./monitoring/monitoring-01.svg2": 41805,
	"./monitoring/monitors_overview-01.svg2": 7738,
	"./monitoring/save-01.svg2": 14672,
	"./monitoring/select_workflow-01.svg2": 48095,
	"./monitoring/setup-01.svg2": 85819,
	"./monitoring/view_manage_monitors-01.svg2": 93503,
	"./movable-01.svg2": 24322,
	"./movable.svg2": 6039,
	"./nav_billing.svg2": 49251,
	"./nav_contacts.svg2": 32850,
	"./nav_dashboard.svg2": 63310,
	"./nav_monitoring-01.svg2": 1613,
	"./nav_reports.svg2": 97921,
	"./nav_settings.svg2": 74269,
	"./nav_templates.svg2": 79379,
	"./num-status.svg2": 9049,
	"./num-validation.svg2": 57326,
	"./nylas.svg2": 93082,
	"./omni-channel.svg2": 10932,
	"./opt-in-out.svg2": 61993,
	"./originator.svg2": 68640,
	"./overview-01.svg2": 59472,
	"./payment_methods.svg2": 37825,
	"./personal_details.svg2": 85949,
	"./plus.svg2": 28495,
	"./precipitation.svg2": 51163,
	"./prepaid.svg2": 44498,
	"./pressure.svg2": 61531,
	"./preview.svg2": 77680,
	"./print.svg2": 99480,
	"./process_reports.svg2": 51130,
	"./prod_api.svg2": 59746,
	"./prod_boomlogic.svg2": 19634,
	"./prod_broadcast.svg2": 81677,
	"./prod_inbound.svg2": 23802,
	"./profile_fields.svg2": 33709,
	"./rain.svg2": 80946,
	"./realtime_reporting.svg2": 5546,
	"./redo.svg2": 95403,
	"./reporting-01.svg2": 12873,
	"./reporting_analytical.svg2": 90122,
	"./reporting_system.svg2": 94725,
	"./reports_export.svg2": 54870,
	"./reports_generate.svg2": 46739,
	"./reports_saved.svg2": 31929,
	"./required_fields.svg2": 59360,
	"./satisfaction_survey.svg2": 17917,
	"./save.svg2": 26064,
	"./schedule_send.svg2": 79445,
	"./scheduling.svg2": 1785,
	"./search.svg2": 65147,
	"./secure_lock..svg2": 65442,
	"./security.svg2": 45193,
	"./self-manage.svg2": 25994,
	"./send.svg2": 47531,
	"./service_entries.svg2": 12327,
	"./settings.svg2": 55347,
	"./shortlink.svg2": 77962,
	"./shortlink2.svg2": 31358,
	"./sla.svg2": 38615,
	"./sms_text.svg2": 45106,
	"./snow.svg2": 6891,
	"./social-hours.svg2": 17584,
	"./social_fb-01.svg2": 95412,
	"./social_fb.svg2": 23971,
	"./social_hours-01.svg2": 30627,
	"./social_li-01.svg2": 99427,
	"./social_li.svg2": 8397,
	"./social_x-01.svg2": 78403,
	"./social_x.svg2": 29868,
	"./status.svg2": 25054,
	"./support_ticket.svg2": 33934,
	"./switch_refresh.svg2": 53457,
	"./system_usage-01.svg2": 1452,
	"./system_usage.svg2": 94094,
	"./temperature.svg2": 77944,
	"./template_account.svg2": 73012,
	"./template_boomerang.svg2": 69022,
	"./template_helper.svg2": 55132,
	"./template_rec.svg2": 51758,
	"./tick.svg2": 80455,
	"./tick_circled.svg2": 18061,
	"./tick_list.svg2": 54973,
	"./tiket_reporting.svg2": 35093,
	"./timezones.svg2": 46244,
	"./undo.svg2": 12268,
	"./unicode.svg2": 33858,
	"./unrec-response.svg2": 6526,
	"./upgrades.svg2": 73279,
	"./upload.svg2": 89282,
	"./upload_file-01.svg2": 30339,
	"./user_group-01.svg2": 30344,
	"./user_group.svg2": 96089,
	"./uv.svg2": 68484,
	"./visibility.svg2": 24762,
	"./weather_conditions_icons/clear_sky-01.svg2": 75762,
	"./weather_conditions_icons/cloudy-01.svg2": 52766,
	"./weather_conditions_icons/drizzle-01.svg2": 75802,
	"./weather_conditions_icons/fog-01.svg2": 62901,
	"./weather_conditions_icons/gust-01.svg2": 58270,
	"./weather_conditions_icons/heavy_rain-01.svg2": 63775,
	"./weather_conditions_icons/heavy_rain_shower-01.svg2": 22402,
	"./weather_conditions_icons/heavy_snow-01.svg2": 34063,
	"./weather_conditions_icons/heavy_snow_shower-01.svg2": 40810,
	"./weather_conditions_icons/humidity-01.svg2": 46959,
	"./weather_conditions_icons/light_rain-01.svg2": 22052,
	"./weather_conditions_icons/light_rain_shower-01.svg2": 68380,
	"./weather_conditions_icons/light_snow-01.svg2": 86005,
	"./weather_conditions_icons/light_snow_shower-01.svg2": 83572,
	"./weather_conditions_icons/max_screen_temp-01.svg2": 17894,
	"./weather_conditions_icons/min_screen_temp-01.svg2": 41999,
	"./weather_conditions_icons/mist-01.svg2": 35375,
	"./weather_conditions_icons/overcast-01.svg2": 23181,
	"./weather_conditions_icons/partly_cloudy-01.svg2": 20077,
	"./weather_conditions_icons/probability_hail-01.svg2": 59906,
	"./weather_conditions_icons/probability_of_snow_visibility-01.svg2": 16025,
	"./weather_conditions_icons/probability_precipitation-01.svg2": 35662,
	"./weather_conditions_icons/probability_sferics-01.svg2": 38312,
	"./weather_conditions_icons/sea-level-pressure-01.svg2": 44325,
	"./weather_conditions_icons/significant_weather-01.svg2": 66866,
	"./weather_conditions_icons/sleet-01.svg2": 69480,
	"./weather_conditions_icons/sleet_shower-01.svg2": 27192,
	"./weather_conditions_icons/sunny-01.svg2": 14184,
	"./weather_conditions_icons/thunder-01.svg2": 78768,
	"./weather_conditions_icons/thunder_shower-01.svg2": 35625,
	"./weather_conditions_icons/uv-index-01.svg2": 88396,
	"./weather_conditions_icons/weather_conditions.svg2": 99078,
	"./weather_conditions_icons/weather_conditions_alt.svg2": 28516,
	"./weather_conditions_icons/wind_direction.svg2": 72186,
	"./weather_conditions_icons/wind_direction_old.svg2": 6300,
	"./weather_conditions_icons/wind_speed-01.svg2": 94045,
	"./weather_conditions_icons/wind_speed-01_old.svg2": 17515,
	"./web-forms.svg2": 24166,
	"./whatsapp.svg2": 77827,
	"./wind_direction.svg2": 75751,
	"./workflows.svg2": 66875,
	"./xls_files-01.svg2": 29864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68396;